import { SsoConnectionUser } from '@choco-admin/types';
import { Tooltip } from '@heroui/react';
import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

import { issueLabel, userConfigIssues } from '../../utils';

export interface UserIssueWarningProps {
  user: SsoConnectionUser;
}

/**
 * Marks a row whose configuration will not do what the reader expects.
 *
 * The tooltip names the specific problem rather than saying "misconfigured",
 * because the fix differs per problem and the reader is the person who has to
 * make it.
 */
export const UserIssueWarning: React.FC<UserIssueWarningProps> = ({ user }) => {
  const issues = userConfigIssues(user);

  if (issues.length === 0) {
    return null;
  }

  return (
    <Tooltip
      content={
        <div className="max-w-xs space-y-2 p-1 text-xs">
          {issues.map((issue) => (
            <p key={issue.kind}>
              <span className="font-semibold">{issueLabel(issue.kind)}. </span>
              {issue.message}
            </p>
          ))}
        </div>
      }
    >
      <span
        className="cursor-help text-warning"
        aria-label={`Needs attention: ${issues
          .map((issue) => issueLabel(issue.kind))
          .join(', ')}`}
      >
        <FiAlertTriangle className="h-4 w-4" />
      </span>
    </Tooltip>
  );
};
